import React from "react";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import { useFileUpload } from "../organisms/FileUploadZone";

export default function AttachmentButton({ 
  size = "md",
  color = "gray"
}) {
  const { triggerFileInput, disabled, isUploading } = useFileUpload();

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    triggerFileInput();
  };

  const button = (
    <UnstyledButton
      onClick={handleClick}
      disabled={disabled || isUploading}
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size === 'sm' ? 32 : size === 'lg' ? 48 : 40,
        height: size === 'sm' ? 32 : size === 'lg' ? 48 : 40,
        borderRadius: theme.radius.sm,
        border: `1px solid ${theme.colors[color][4]}`,
        color: theme.colors[color][6],
        cursor: disabled || isUploading ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: theme.colors[color][0],
          color: theme.colors[color][7],
        },
        '&:disabled': {
          opacity: 0.6,
          cursor: 'not-allowed',
        }
      })}
    >
      <FontAwesomeIcon 
        icon={solid("cloud-arrow-up")} 
        size={size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : '1x'}
        color={"#ced4da"}
      />
    </UnstyledButton>
  );

  return button;
}
